export default "__VITE_ASSET__Df5dFch5__"